import { getHawkeyeApi } from '@/shared/utils/getHawkeyeApi'

type GetFirebaseCustomTokenType = (p: {
  jobId: string
  apiKey: string
}) => Promise<string>

export const getFirebaseCustomToken: GetFirebaseCustomTokenType = async ({
  jobId,
  apiKey
}) => {
  try {
    const headers = new Headers({
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Content-TyprequestOptionse': 'application/json',
      'x-api-key': apiKey
    })

    const options = {
      headers
    }

    const request = await fetch(`${getHawkeyeApi()}/token/${jobId}`, options)
    const response = await request.json()
    return response.token
  } catch (error) {
    console.error('error getFirebaseCustomToken', error)
  }
  return ''
}
